import { NgModule } from '@angular/core';
import { FeatureGitClient, FEATURE_WASM_GIT_WEB_WORKER } from '@y42/feature/git/client';
import { FeatureWasmGitWebWorker } from '@y42/feature/git/worker';
import { GitService } from '@y42/git';

@NgModule({
  providers: [
    {
      provide: GitService,
      useExisting: FeatureGitClient,
    },
    {
      provide: FEATURE_WASM_GIT_WEB_WORKER,
      useValue: FeatureWasmGitWebWorker,
    },
  ],
})
export class Y42GitModule {}
